module.exports = __webpack_public_path__ + "media/images/result_sets/circles/8r7n2n5r-dc9e9280a04ce692235e5e04a1f1aa55.svg";